var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zoom in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.755,11.255 L11.965,11.255 L11.685,10.985 C12.665,9.845 13.255,8.365 13.255,6.755 C13.255,3.165 10.345,0.255 6.755,0.255 C3.165,0.255 0.255,3.165 0.255,6.755 C0.255,10.345 3.165,13.255 6.755,13.255 C8.365,13.255 9.845,12.665 10.985,11.685 L11.255,11.965 L11.255,12.755 L16.255,17.745 L17.745,16.255 L12.755,11.255 Z M6.755,11.255 C4.265,11.255 2.255,9.245 2.255,6.755 C2.255,4.265 4.265,2.255 6.755,2.255 C9.245,2.255 11.255,4.265 11.255,6.755 C11.255,9.245 9.245,11.255 6.755,11.255 Z M7.255,4.255 L6.255,4.255 L6.255,6.255 L4.255,6.255 L4.255,7.255 L6.255,7.255 L6.255,9.255 L7.255,9.255 L7.255,7.255 L9.255,7.255 L9.255,6.255 L7.255,6.255 L7.255,4.255 Z",
    id: "path-1908"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "23-Jun-2020---Sanitized",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.25---4",
    transform: "translate(-475.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/editor/title_24px-copy-3",
    transform: "translate(459.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4902",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1908"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/zoom_in_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-4902)",
    fill: "#222222"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -3.000000)",
    id: "Rectangle-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.484730b861909f7e059e6c7dbbd39132.svg";
export { ForwardRef as ReactComponent };